import { memo } from "react";

function NotCompletedMarker(props) {
  const { backgroundColor = "#666666", borderColor, size = 27 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10100_47028)">
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          fill={backgroundColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 5.72581C5 5.32496 5.32496 5 5.72581 5H14.4924C14.8932 5 15.2182 5.32496 15.2182 5.72581C15.2182 6.12665 14.8932 6.45161 14.4924 6.45161H6.45161V18.5484H18.5484V10.1091C18.5484 9.70826 18.8734 9.3833 19.2742 9.3833C19.675 9.3833 20 9.70826 20 10.1091V19.2742C20 19.675 19.675 20 19.2742 20H5.72581C5.32496 20 5 19.675 5 19.2742V5.72581Z"
          fill={borderColor}
        />
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          stroke={borderColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_10100_47028">
          <rect width="24" height="24" fill={borderColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(NotCompletedMarker);
